// extracted by mini-css-extract-plugin
module.exports = {"container":"_20S7D1s"};